import { createContext, useContext, useMemo, type ReactNode } from 'react';

interface AuthContextValue {
  jwt: string | null;
  requestTokenRefresh: () => void;
}

const AuthContext = createContext<AuthContextValue>({
  jwt: null,
  requestTokenRefresh: () => {},
});

interface AuthProviderProps {
  children: ReactNode;
  jwt: string | null;
  requestTokenRefresh: () => void;
}

export function AuthProvider({ children, jwt, requestTokenRefresh }: AuthProviderProps) {
  const value = useMemo(() => ({ jwt, requestTokenRefresh }), [jwt, requestTokenRefresh]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
